<template>
  <b-row>
    <b-col cols="12">
      <b-row
        align-h="between"
        class="mb-50"
      >
        <b-col cols="10">
          <div style="display: flex;justify-content: center;">
            <h4 style="margin-left: 8rem;">
              Configuração de cobrança</h4>
            <div style="padding-left: 0.4rem">
              <i
                v-b-tooltip.hover
                :title="descricao"
                style="font-size: 0.85rem;"
                class="question-icon"
              >
                <font-awesome-icon
                  :icon="faQuestionCircle"
                />
              </i>
            </div>
          </div>
        </b-col>
        <b-col
          cols="auto"
        >
          <b-btn
            v-b-tooltip.hover
            title="Download planilha"
            variant="none"
            @click="gerarDados"
          >
            <font-awesome-icon
              :icon="faDownload"
            />
          </b-btn>
          <a
            id="download"
            download
            href=""
            hidden
          />
        </b-col>
      </b-row>
      <b-row v-if="carregado">
        <b-col cols="6">
          <dashboard-meia-rosca
            :valor="dado.totalEmpresasComCobranca"
          />
        </b-col>
        <b-col cols="6">
          <dashboard-meia-rosca
            :valor="dado.totalEmpresasSemCobranca"
            :color="'rgba(214, 40, 57)'"
          />
        </b-col>
      </b-row>
      <b-row
        v-if="carregado"
        align-h="between"
        class="mt-1"
      >
        <b-col cols="4">
          <div class="legenda">
            <div
              style="background-color: #5fad56;"
              class="square"
            />
            <h5>Com configuração</h5>
          </div>
          <div>
            <span>{{ dado.empresasConfiguradas }}</span>
          </div>
        </b-col>
        <b-col cols="4">
          <div class="legenda">
            <div
              style="background-color: #d62839;"
              class="square"
            />
            <h5>Sem configuração</h5>
          </div>
          <div>
            <span>{{ dado.empresasSemConfiguracao }}</span>
          </div>
        </b-col>
        <b-col cols="2">
          <div>
            <h5>Total</h5>
            <span>{{ dado.totalEmpresasAtivas }}</span>
          </div>
        </b-col>
      </b-row>
    </b-col>
  </b-row>
</template>

<style lang="scss">
.square {
  height: 15px;
  width: 15px;
  margin-right: 0.5rem;
}

.legenda {
  display: flex;
  align-items: baseline;
}

span {
  color: var(--chart-text-color);
}

</style>

<script>
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import {
  faQuestionCircle, faDownload,
} from '@fortawesome/free-solid-svg-icons'
import api from '@/app-modulo/documento/dashboard-cobranca/shared/services/api'

export default {
  name: 'ConfiguracaoCobranca',
  components: {
    FontAwesomeIcon,
    DashboardMeiaRosca: () => import('@/shared/components/grafico-meia-rosca/GraficoMeiaRosca.vue'),
  },
  data() {
    return {
      faQuestionCircle,
      faDownload,
      carregado: false,
      dado: {},
      camposConfigurados: ['Razão Social', 'Inscrição', 'Matriz/Filial', 'Departamento configurado'],
      camposNaoConfigurados: ['Razão Social', 'Inscrição', 'Matriz/Filial', 'Departamento não configurado'],
      descricao: 'Para esse índice é validado nas empresas ativas se existe configuração de cobrança nas abas "Modelos e Documentos", "Contatos" e "Responsáveis" respeitando as regras de cada equipe. Regras: Equipe Azul - deve ter obrigatoriamente o departamento RH Folha configurado. Demais equipes, se a empresa é Filial deve ter obrigatoriamente no mínimo o departamento Fiscal configurado, se a empresa é Matriz deve ter obrigatoriamente no mínimo os departamentos Contábil e Fiscal configurado.',
    }
  },
  created() {
    this.carregarDados()
  },
  methods: {
    carregarDados() {
      api.getComESemConfiguracaoCobranca()
        .then(payload => {
          this.dado = payload.data
          this.carregado = true
        })
    },
    gerarDados() {
      this.$isLoading(true)
      this.gerarDadosConfiguracao()
        .then(payload => {
          if (payload) {
            this.gerarDadosSemConfiguracao()
              .then(() => {
                this.$sucesso('Planilhas geradas com sucesso')
              })
              .catch(err => {
                this.$erro(err)
                throw err
              })
              .finally(() => {
                this.$isLoading(false)
              })
          }
        })
        .catch(err => {
          this.$isLoading(false)
          this.$erro(err)
          throw err
        })
    },
    gerarDadosConfiguracao() {
      return new Promise((resolve, reject) => {
        this.$isLoading(true)
        api.gerarPlanilhaConfigurada(this.camposConfigurados)
          .then(payload => {
            if (payload.data.url !== '') {
              document.getElementById('download').href = payload.data.url
              document.getElementById('download').click()
            }
            this.deletarUpload(payload.data.fileName)
            resolve(true)
          })
          .catch(err => {
            this.$erro(err)
            reject(err)
          })
      })
    },
    gerarDadosSemConfiguracao() {
      return new Promise((resolve, reject) => {
        this.$isLoading(true)
        api.gerarPlanilhaNaoConfigurada(this.camposNaoConfigurados)
          .then(payload => {
            if (payload.data.url !== '') {
              document.getElementById('download').href = payload.data.url
              document.getElementById('download').click()
            }
            this.deletarUpload(payload.data.fileName)
            resolve(true)
          })
          .catch(err => {
            this.$erro(err)
            reject(err)
          })
      })
    },
    deletarUpload(data) {
      setTimeout(() => {
        api.deleteUpload(data)
      }, 3000)
    },
  },
}
</script>
